'use client';

import { FC } from 'react';

export interface LoadingProps {
    size?: 'small' | 'medium' | 'large';
    testId: string;
    overlay?: boolean;
}

const Loading: FC<LoadingProps> = (props) => {
    const { size = 'small', overlay = false } = props;

    // Sizes
    let sizeClassName = 'loading-sm';
    if (size === 'medium') {
        sizeClassName = 'loading-md';
    } else if (size === 'large') {
        sizeClassName = 'loading-lg';
    }

    if (!overlay) {
        return <span className={`loading loading-spinner ${sizeClassName}`} data-test-id={props.testId}></span>;
    } else {
        return (
            <div className="fixed inset-0 flex items-center justify-center bg-black/60 z-50">
                <span
                    className={`loading loading-spinner text-white ${sizeClassName} w-12 h-12`}
                    data-test-id={props.testId}
                />
            </div>
        );
    }
};

export default Loading;
